import * as Needle from '@neo4j-ndl/react';
import { EyeIconOutline, EyeSlashIconOutline } from '@neo4j-ndl/react/icons';
import * as React from 'react';

type TextInputProps = React.ComponentProps<typeof Needle.TextInput>;

type PasswordInputProps = Omit<TextInputProps, 'rightElement'> & { allowReveal?: boolean };

function PasswordInputRenderer(props: PasswordInputProps, ref: React.ForwardedRef<HTMLInputElement>) {
  const [reveal, setReveal] = React.useState(false);

  return (
    <Needle.TextInput
      {...props}
      ref={ref}
      htmlAttributes={{
        ...props.htmlAttributes,
        type: reveal ? 'text' : 'password',
      }}
      rightElement={
        props.allowReveal === true ? (
          <Needle.IconButton
            htmlAttributes={{ type: 'button' }}
            onClick={(event) => {
              event.preventDefault();
              setReveal((value) => !value);
            }}
            isClean
            ariaLabel={reveal ? 'hide password' : 'show password'}
            className="relative left-1.5"
          >
            {reveal ? <EyeIconOutline /> : <EyeSlashIconOutline />}
          </Needle.IconButton>
        ) : undefined
      }
    />
  );
}

export const PasswordInput = React.forwardRef(PasswordInputRenderer);
